export * from './vanilla/index';
//# sourceMappingURL=vanilla.js.map


// WEBPACK FOOTER //
// ./~/@uirouter/core/lib-esm/vanilla.js